import React from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { type DataExportMetric } from "../../types";

interface SelectedMetricProps {
  metric: DataExportMetric;
  isEdited: boolean;
  onRemove: () => void;
}

export function SelectedMetric({
  metric,
  isEdited,
  onRemove,
}: SelectedMetricProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id: metric.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      className={clsx(
        "border rounded-md border-blue-300 bg-cosmic-4 hover:bg-cosmic-3",
        "hover:border-cosmic-3 text-[12px] font-light pl-2 pr-2 pt-1.5 pb-1.5",
        "flex items-center",
        { "bg-cosmic-3 border-cosmic-3": isEdited },
      )}
      style={style}
    >
      <i
        ref={setActivatorNodeRef}
        className="fa-regular fa-sharp fa-grip-dots text-blue-500 cursor-move mr-2"
        {...attributes}
        {...listeners}
      ></i>
      <span className="flex-1">{metric.label}</span>
      <GenericTooltip noInfoCircle content="Remove metric">
        <button
          className="w-6 h-6 rounded-full text-mars+2 ml-0.5 hover:bg-white"
          onClick={() => {
            onRemove();
          }}
        >
          <i className="fa-regular fa-sharp fa-trash text-xs" />
        </button>
      </GenericTooltip>
    </div>
  );
}
